module.exports = __webpack_public_path__ + "img/symbol_2.39574b14.png";